<div class="toast-container">
    <div class="toast {{ type }}">
        <i class="{{ icon }}"></i>
        <div class="toast-content">
            <div class="toast-title">{{ title }}</div>
            <div class="toast-message">{{ message }}</div>
        </div>
    </div>
</div>
